<template>
  <div>
    <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%;height: 100%"
        :header-cell-style="{background: '#f2f2f2',color: '#fff;'}"
        header-cell-class-name="tab-head"
    >
      <el-table-column prop="user_real_name" label="姓名" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.user_real_name}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="states" label="简历状态" align="center">
        <template slot-scope="scope">
          <div class="resume-state"
               :class="[{active1:(scope.row.states === 1 || scope.row.states === 4 || scope.row.states === 6)},
                  {active2:(scope.row.states === 2 || scope.row.states === 5|| scope.row.states === 7|| scope.row.states === 8)},
                  {active3:(scope.row.states === 3 || scope.row.states === 8)},
                  {active4:(scope.row.states === 9 )}]"
          >{{scope.row.states | states}}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="address_id" label="城市" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.address_id}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="birthday" label="年龄" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.birthday}}</span>
        </template>
      </el-table-column>

      <el-table-column prop="deliver_methods" label="来源" align="center">
        <template slot-scope="scope">
          <span style="color:#00a2ea;background: #f0f9eb" class="la" :class="{laActive:scope.row.deliver_methods!==1}">{{scope.row.deliver_methods | methods}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="resume_id" label="查看" align="center">
        <template slot-scope="scope">
                <span style="color:#00a2ea;cursor: pointer;"
                      @click="toDetail(scope.row.resume_id,scope.row.deliver_methods)">查看</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "resumeList",
  data() {
    return {
      tableData:[]
    }
  },
  created() {
    this.getResume()
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  methods: {
    toDetail(resume_id,deliver_methods){
      if(Number(deliver_methods) === 4){
        this.$router.push('/home/zwAdmin/resume2/' + resume_id + '?jobId=' + this.$route.params.id)
      }else{
        this.$router.push('/home/zwAdmin/resume/' + resume_id)
      }
    },


    // 获取简历列表
    getResume() {
      console.log(123)
      this.$api.apiContent.positionCans({
        id:this.$route.params.id,
        admin_id:this.user.id,
        page: 1,
        limit: 1000
      }).then(res => {
        this.tableData = res.data

      })
    }
  },
  filters: {
    //  简历状态
    states(val) {
      let num = Number(val)
      let str = ''
      switch (num) {
        case 1:
          str = '处理中'
          break
        case 2:
          str = '面试邀请'
          break
        case 3:
          str = '拒绝'
          break
        case 4:
          str = '已搁置'
          break
        case 5:
          str = '录用'
          break
        case 6:
          str = '未面试'
          break
        case 7:
          str = '已面试'
          break
        case 8:
          str = '对方拒绝面试'
          break
        case 9:
          str = '对方同意面试'
          break
        case 10:
          str = '取消面试'
          break

      }
      return str
    },
    methods(val) {
      let num = Number(val)
      let str = ''
      switch (num) {
        case 1:
          str = '直投'
          break
        case 2:
          str = '普通推荐'
          break
        case 3:
          str = '金牌推荐'
          break
        case 4:
          str = '熟人推荐'
          break
      }
      return str
    },
    // 工作性质
    nature(val) {
      let num = Number(val)
      if (num === 1) {
        return '全职'
      } else if (num === 2) {
        return '实习'
      } else if (num === 3) {
        return '兼职'
      }else if (num === 4) {
        return '活动'
      }
    },
  },
  watch: {},
}
</script>

<style scoped lang="scss">

</style>